module.exports = __webpack_public_path__ + "assets/img/android.06db24d2.jpg";